import type { ReactNode } from 'react'

interface GcpStatCardProps {
  label: string
  value: ReactNode
  subtext?: ReactNode
  valueClassName?: string
  onClick?: () => void
}

export default function GcpStatCard({
  label,
  value,
  subtext,
  valueClassName = 'text-gray-900',
  onClick,
}: GcpStatCardProps) {
  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white p-4 shadow-sm${onClick ? ' cursor-pointer hover:border-gray-300 hover:bg-gray-50' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                onClick()
              }
            }
          : undefined
      }
    >
      <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</p>
      <p className={`mt-1 text-xl font-semibold ${valueClassName}`}>{value}</p>
      {subtext ? <p className="mt-1 text-sm text-gray-500">{subtext}</p> : null}
    </div>
  )
}
